import { YANDEX_METRIKA_ID, PIXEL_ID, ADRIVER_ID } from "@/utils/constans";
// import { useHead } from "@unhead/vue";

export function sendMetrik(event, goal) {
	if (window.ym) {
		window.ym(YANDEX_METRIKA_ID, event, goal);
		// console.log('gale:', event ,goal);
	} else {
		console.warn("Яндекс.Метрика не загружена.");
	}
}

export const smartPixel = (goal) => {
	if (typeof _txq !== "undefined") {
		_txq.push(["track", goal]);
		// console.log('smartPixel:',goal);
	} else {
		console.warn("_txq is not defined");
	}
};

export const pushEvent = (eventName) => {
	if (typeof window !== "undefined" && window.dataLayer) {
		window.dataLayer.push({ event: eventName });
	}
};

export const metricScrolling = (position, sentMetrics) => {
	const checkpoints = [25, 50, 75, 100];

	checkpoints.forEach((checkpoint) => {
		if (position >= checkpoint && !sentMetrics.has(checkpoint)) {
			sentMetrics.add(checkpoint);
			if (checkpoint === 100) {
				sendMetrik("reachGoal", "scroll_footer");
			} else {
				sendMetrik("reachGoal", `scroll${checkpoint}`);
			}
		}
	});
};

export const initTimeMetrics = (sentMetrics) => {
	if (typeof window === "undefined") return;

	setTimeout(() => {
		if (!sentMetrics.has("timer-15")) {
			sentMetrics.add("timer-15");
			sendMetrik("reachGoal", "timer-15");
		}
	}, 15000);

	setTimeout(() => {
		if (!sentMetrics.has("timer-60")) {
			sentMetrics.add("timer-60");
			sendMetrik("reachGoal", "timer-60");
		}
	}, 60000);
};

export function initYandexMetrika() {
	window.dataLayer = window.dataLayer || [];
	(function (m, e, t, r, i, k, a) {
		m[i] =
			m[i] ||
			function () {
				(m[i].a = m[i].a || []).push(arguments);
			};
		m[i].l = 1 * new Date();
		for (var j = 0; j < document.scripts.length; j++) {
			if (document.scripts[j].src === r) {
				return;
			}
		}
		((k = e.createElement(t)), (a = e.getElementsByTagName(t)[0]), (k.async = 1), (k.src = r), a.parentNode.insertBefore(k, a));
	})(window, document, "script", `https://mc.yandex.ru/metrika/tag.js?id=${YANDEX_METRIKA_ID}`, "ym");

	ym(YANDEX_METRIKA_ID, "init", { ssr: true, webvisor: true, clickmap: true, ecommerce: "dataLayer", referrer: document.referrer, url: location.href, accurateTrackBounce: true, trackLinks: true });
}

export function sendAdriver(goal) {
	if (typeof AdriverCounterJS === "undefined") {
		console.warn("AdriverCounterJS not loaded");
		return;
	}

	window.adrCounterStorage = window.adrCounterStorage || [];
	window.adrCounterStorage.push(function () {
		new AdriverCounterJS(
			{
				sid: 230164,
				bt: 62,
				sz: goal,
			},
			{
				id: "",
				gid1: "",
				yid1: "",
			},
		);
	});
}
export function trackAdriver(eventLabel) {

	!(function (e, n) {
		function o(e, n, o) {
			((n = n || "&"), (o = o || "="));
			var d = [];
			for (var r in e) e.hasOwnProperty(r) && d.push(r + o + encodeURIComponent(e[r]));
			return d.join(n);
		}
		function d(e, n) {
			var o = e.cookie.match("(^|;) ?" + n + "=([^;]*)(;|$)");
			return o ? decodeURIComponent(o[2]) : null;
		}
		var r, t, i, c, u;
		((r = e),
			(t = n),
			(i = document.domain),
			(c = { tail256: document.referrer || "unknown" }),
			void 0 !==
				(u = (function (e) {
					var n = {};
					if (e) {
						var o = e.split("&");
						for (var d in o)
							if (o.hasOwnProperty(d)) {
								var r = o[d].split("=");
								void 0 !== r[0] && void 0 !== r[1] && (n[r[0]] = decodeURIComponent(r[1]));
							}
					}
					return n;
				})(window.location.search.substring(1))).adrclid && (r.fsid = u.adrclid),
			null !== d(document, "adrcid") && (r.cid = d(document, "adrcid")),
			t && t.id && null !== d(document, t.id) && (r.suid = i + "_" + encodeURIComponent(d(document, t.id))),
			t && t.gid1 ? (r.gid1 = t.gid1) : null !== d(document, "_ga") && (r.gid1 = encodeURIComponent(d(document, "_ga"))),
			t && t.yid1 ? (r.yid1 = t.yid1) : null !== d(document, "_ym_uid") && (r.yid1 = encodeURIComponent(d(document, "_ym_uid"))),
			(r.loc = encodeURIComponent(window.location.href)),
			r.custom && (r.custom = o(r.custom, ";")),
			(function (e, n) {
				!(function (e) {
					if (((e = e.split("![rnd]").join(~~(1e6 * Math.random()))), document.createElement && document.body)) {
						var n = document.createElement("img");
						((n.style.position = "absolute"), (n.style.display = "none"), (n.style.width = n.style.height = "0px"), n.setAttribute("referrerpolicy", "no-referrer-when-downgrade"), (n.src = e), document.body.appendChild(n));
					} else {
						var o = new Image();
						(o.setAttribute("referrerpolicy", "no-referrer-when-downgrade"), (o.src = e));
					}
				})("https://ad.adriver.ru/cgi-bin/rle.cgi?" + e + "&rnd=![rnd]" + (n ? "&" + n : ""));
			})(o(r), o(c)));
	})({ sid: Number(ADRIVER_ID), bt: 62, sz: eventLabel }, { id: "", gid1: "", yid1: "" });

	// console.log('trackAdriver:',eventLabel, Number(ADRIVER_ID));
}

export function trackPixel(pixelType, pixelId) {
	if (!window.__GetI) {
		window.__GetI = [];
	}
	(function () {
		var p = {
			type: pixelType,
			/* config START */
			site_id: PIXEL_ID, //10215
			product_id: "",
			product_price: "",
			category_id: "",
			pixel_id: pixelId,
			/* config END */
		};
		window.__GetI.push(p);
	})();

	// console.log("trackPixel()", pixelType, pixelId, PIXEL_ID);
}

export function adsHeadsCheck() {
	let img = document.createElement("img");
	img.src = `https://ads-heads.ru/c/rl.gif?label=RLlflHBO&ttl={TTL}&rid=289052093`;
	img.width = 1;
	img.height = 1;
	img.style.display = "none";
	document.body.appendChild(img);
}
export function adsHeadsRegistration() {
	let img = document.createElement("img");
	let TTL = new Date().getTime();
	img.src = `https://ads-heads.ru/c/rl.gif?label=RL52NL0z&ttl={TTL}&rid=68477918`;
	img.width = 1;
	img.height = 1;
	img.style.display = "none";
	document.body.appendChild(img);
}
